/**
 * Action types for ntp sync functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of ntp sync.
 */

// Get ntp sync constants
export const NTP_SYNC_REQUEST_GET = 'NTP_SYNC_REQUEST_GET';
export const NTP_SYNC_RESPONSE_GET_SUCCESS = 'NTP_SYNC_RESPONSE_GET_SUCCESS';
export const NTP_SYNC_RESPONSE_GET_FAIL = 'NTP_SYNC_RESPONSE_GET_FAIL'
